import { FC, Fragment, useReducer } from 'react';

import { Plus } from 'lucide-react';
import { toast } from 'sonner';
import useSWRMutation from 'swr/mutation';

import Button from '@mui/material/Button';

import { CasinoAbTestFormDialog } from '../casinoAbTestFormDialog/CasinoAbTestFormDialog';
import { CasinoAbTestForm, initialValues } from '../casinoAbTestFormDialog/form';

import { abTestsService } from 'v2/api/abTestsService';
import { handleHttpError } from 'v2/utils';

interface CreateCasinoAdFormProps {
  onSuccess: VoidFunction;
}

export const CreateCasinoAbTestButton: FC<CreateCasinoAdFormProps> = ({ onSuccess }) => {
  const [isOpen, setOpen] = useReducer((state) => !state, false);

  const { trigger, isMutating } = useSWRMutation('createCasinoAbTest', abTestsService.createCasinoAbTest, {
    onSuccess: () => {
      toast.success('The test has been created successfully');
      onSuccess();
      setOpen();
    },
    onError: handleHttpError,
  });

  const handleSubmit = (values: CasinoAbTestForm, resetForm: VoidFunction) => {
    trigger(values).then(() => resetForm());
  };

  return (
    <Fragment>
      <Button onClick={setOpen} startIcon={<Plus />} variant="contained" size="large">
        Create AB Test
      </Button>

      <CasinoAbTestFormDialog
        title="Create AB Test"
        initialValues={initialValues}
        isOpen={isOpen}
        onClose={setOpen}
        isSubmitting={isMutating}
        onSubmit={handleSubmit}
      />
    </Fragment>
  );
};
